export const GAME_MERRY_CHRISMAS = 'merry-christmas';
export const GAME_WORLD_CUP = 'world-cup';
export const GAME_LOOK_BACK = 'look-back';
export const GAME_BIRTHDAY = 'birthday';
export const GAME_BRING_COIN_HOME = 'bringcoinhome';

export const UNAUTHENCATION_EVENT = 'UNAUTHENCATION_EVENT';
export const UNAUTHENCATION_EVENT_DATA = 'UNAUTHENCATION_EVENT_DATA';
